import {
    animate,
    keyframes,
    state,
    style,
    transition,
    trigger
} from '@angular/animations';
import { Component, ChangeDetectionStrategy, ChangeDetectorRef, Input } from '@angular/core';
import { Toast, ToastPackage, ToastrService } from 'ngx-toastr';

@Component({
    selector: 'app-loading-toast',
    templateUrl: './loading-toast.component.html',
    styleUrls: ['./loading-toast.component.scss'],
    animations: [
        trigger('flyInOut', [
            state('inactive', style({
                opacity: 0,
            })),
            transition('inactive => active', animate('400ms ease-out', keyframes([
                style({
                    transform: 'translate3d(100%, 0, 0) skewX(-30deg)',
                    opacity: 0,
                }),
                style({
                    transform: 'skewX(20deg)',
                    opacity: 1,
                }),
                style({
                    transform: 'skewX(-5deg)',
                    opacity: 1,
                }),
                style({
                    transform: 'none',
                    opacity: 1,
                }),
            ]))),
            transition('active => removed', animate('400ms ease-out', keyframes([
                style({
                    opacity: 1,
                }),
                style({
                    transform: 'translate3d(100%, 0, 0) skewX(30deg)',
                    opacity: 0,
                }),
            ]))),
        ]),
    ],
    changeDetection: ChangeDetectionStrategy.OnPush, // 👈 fix principal del error
    preserveWhitespaces: false,
    standalone: false
})
export class LoadingToastComponent extends Toast {
    @Input() tipoAlert: any;
    undoString = 'undo';

    constructor(
        protected override toastrService: ToastrService,
        public override toastPackage: ToastPackage,
        private cdr: ChangeDetectorRef
    ) {
        super();
    }

    action(event: Event) {
        event.stopPropagation();
        this.undoString = 'undid';
        this.cdr.markForCheck();
        this.toastPackage.triggerAction();
        return false;
    }
}